var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _c("strong", [
        _vm._v(
          _vm._s(_vm.assets.length) +
            " " +
            _vm._s(_vm.$t("mediaGallery.loadMore.xOfY")) +
            " " +
            _vm._s(_vm.totalAssets)
        ),
      ]),
      _vm._v(" "),
      _c(
        "global-button",
        {
          attrs: { theme: "secondary", disabled: _vm.disableLoadMore },
          on: { click: _vm.handleLoadMore },
        },
        [_vm._v(_vm._s(_vm.$t("mediaGallery.loadMore.button")))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }